import * as React from 'react';
import {
  Heading1,
  Heading5,
  Paragraph,
  Flex,
  thc,
} from '@flightstats/airframe-react';

const Container = thc(Flex, {
  height: '100%',
  flex: '1 1 100%',
  justifyContent: 'space-around',
});

const Contents = thc(Flex, {
  flexDirection: 'column',
  justifyContent: 'center',
  textAlign: 'center',
  margin: '0 auto',
  maxWidth: '300px',
  mb: '30px',
});

export const CiriumErrorPage: React.FC = () => (
  <Container>
    <Contents>
      <Heading1>OOPS!</Heading1>
      <Heading5>Data not available</Heading5>
      <Paragraph>
        We are unable to retrieve your information at this time
      </Paragraph>
    </Contents>
  </Container>
);